import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { hardwareService } from "~/services";
import { Product, ProductClassMapping } from "~/types/Product";
import { SKU } from "~/types/SKU";
import { RootState } from "..";

type initState = {
    current: Product | null;
    data: Array<Product>;
    open: boolean;
    isEdit: boolean;
    productClassMappings: ProductClassMapping[];
    skus: Array<SKU>;
}

const initialState: initState = {
    current: null,
    data: [],
    open: false,
    isEdit: false,
    productClassMappings: [],
    skus: [],
}

export const fetchProducts = createAsyncThunk(`product/fetchProducts`, async () => {
    try {
        const data = await hardwareService.getProducts();
        return data;
    } catch (error) {
        console.error(error);
        return [];
    }
});

export const fetchSKUs = createAsyncThunk(`product/fetchSKUs`, async () => {
    try {
        const data = await hardwareService.getSKUs();
        return data;
    } catch (error) {
        console.error(error);
        return [] as SKU[];
    }
});

export const fetchProductClassMappings = createAsyncThunk(`product/fetchProductClassMappings`, async () => {
    try {
        return await hardwareService.getProductClassMapping();
    } catch (error) {
        console.error(error);
        return [] as ProductClassMapping[];
    }
}
);

export const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {
        setCurrentProduct: (state, action: PayloadAction<Product>) => {
            state.current = action.payload;
        },
        setProducts: (state, action: PayloadAction<Array<Product>>) => {
            state.data = action.payload;
        },
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setIsEdit: (state, action: PayloadAction<boolean>) => {
            state.isEdit = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchProducts.fulfilled, (state, action) => {
            state.data = action.payload;
            if (!state.open && state.current) {
                state.current = action.payload.find((p) => p.id === state.current?.id) ?? null;
            }
        });
        builder.addCase(fetchSKUs.fulfilled, (state, action) => {
            state.skus = action.payload;
        });
        builder.addCase(fetchProductClassMappings.fulfilled, (state, action) => {
            state.productClassMappings = action.payload;
        });
    }
});

export const productActions = productSlice.actions;
export default productSlice.reducer;

export const productData = (state: RootState) => state.product.data;
export const productCurrent = (state: RootState) => state.product.current;
export const productOpen = (state: RootState) => state.product.open;
export const productClassMappings = (state: RootState) => state.product.productClassMappings;
export const productSkus = (state: RootState) => state.product.skus;